import { Link } from "react-router-dom";

const FriendGridItem = ({ friend }) => {
    const avatarSrc = friend.profilePic?.startsWith("http")
        ? friend.profilePic
        : (friend.profilePic || "/public/noAvatar.png");

    return (
        <Link
            to={`/profile/${friend.id}`}
            style={{ textDecoration: "none", color: "inherit", display: "block" }}
        >
            <div className="friendItem">
                <img src={avatarSrc} alt={friend.name} />

                <span className="friendName">
                    {friend.name}
                </span>
            </div>
        </Link>
    );
};

export default FriendGridItem;